<template>
  <div class="p-availablePlan">
    <div class="c-grid">
      <div class="c-grid__items">
        <div class="c-graphStatus__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__12">
          <div class="p-box">
            <form v-if="!loading && upgradable_plans" class="p-availablePlan__form" @submit.prevent="onSubmit">
              <div class="p-availablePlan__form__main">
                <div class="p-box__body">
                  <h3 class="p-box__title">{{ $t('pages.companies.upgradePlan.selectStoreSlot') }}</h3>
                  <div class="p-availablePlan__form__body">
                    <p class="c-formLabel">{{ $t('pages.companies.upgradePlan.numberOfAvailableStores') }}</p>
                    <div class="p-availablePlan__form__body__select">
                      <div class="c-select">
                        <Select v-model="plan_id" :options="upgradablePlansOptions" />
                      </div>
                    </div>
                    <div class="c-info">
                      <div class="c-info__icon"><Icon name="iconQuestion" /></div>
                      <i18n-t class="c-info__content" keypath="pages.companies.upgradePlan.info" tag="div">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdQv59GcJ_DEyQjj944U1c0TmeGuF-kMkB1lX0ZlSumaFTz5w/viewform" target="_blank">{{ $t('labels.customerSupport') }}</a>
                      </i18n-t>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="selectedPlan" class="p-availablePlan__form__price-board">
                <h3 class="p-availablePlan__form__price-board__title">{{ $t('pages.companies.upgradePlan.paymentDetails') }}</h3>
                <div class="p-availablePlan__form__price-board__price">
                  <p>{{ $t('pages.companies.upgradePlan.availableStoreSlots') }}：</p>
                  <p class="u-fwB">{{ $tc('labels.storesCount', selectedPlan.attributes.max_store_count) }}</p>
                </div>
                <div class="p-availablePlan__form__price-board__price">
                  <p>{{ $t('pages.companies.upgradePlan.increaseInStoreSlots') }}（{{ $t('labels.monthlyDiscount', { number: upgradable_plans_meta.billing_month }) }}）:</p>
                  <p class="u-fwB">{{ $t('labels.currency.yen', { number: selectedPlan.attributes.annual_cost_amount.toLocaleString() }) }}</p>
                </div>
                <div class="p-availablePlan__form__price-board__price">
                  <p>{{ $t('labels.tax') }}：</p>
                  <p class="u-fwB">{{ $t('labels.currency.yen', { number: selectedPlan.attributes.annual_cost_tax_amount.toLocaleString() }) }}</p>
                </div>
                <div class="p-availablePlan__form__price-board__bottom">
                  <div class="p-availablePlan__form__price-board__bottom__total-price">
                    <p class="u-fwB">{{ $t('labels.totalBilledAmount') }}</p>
                    <p class="u-fwB u-colorPrimary">{{ $t('labels.currency.yen', { number: selectedPlan.attributes.total_cost_amount.toLocaleString() }) }}</p>
                  </div>
                  <p class="u-taL">{{ $t('pages.companies.upgradePlan.billDescription') }}</p>
                  <p class="c-checkbox__item p-availablePlan__form__price-board__bottom__checkbox u-pad0">
                    <input id="checkbox1" v-model="isAgree" class="c-checkbox__input" type="checkbox">
                    <i18n-t class="c-checkbox__label p-availablePlan__form__price-board__bottom__checkbox__agreement" keypath="pages.companies.upgradePlan.agreeTerms" for="checkbox1" tag="label">
                      <span class="c-links__item u-pad0">
                        <a :href="servicePrivacyUrl" target="_blank">{{ $t('labels.terms') }}</a>
                      </span>
                    </i18n-t>
                  </p>
                  <button :disabled="!validButton()" :class="submitBtnStyle">
                    {{ $t('pages.companies.upgradePlan.apply') }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <Loading v-show="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select from '../components/Select'
import {mapActions, mapGetters, mapState} from 'vuex'
import Loading from '../components/Loading'
import Icon from '../components/Icon'
import {allServiceUrlConst} from '../modules/serviceUrlConst'

export default {
  name: 'UpgradePlan',
  components: {Icon, Loading, Select},
  data() {
    return {
      isAgree: false,
      plan_id: null,
    }
  },
  computed: {
    ...mapState({
      upgradable_plans: state => state.companiesUpgradablePlans.data.data,
      upgradable_plans_meta: state => state.companiesUpgradablePlans.data.meta,
      loading: state => state.companiesUpgradablePlans.loading || state.companiesAvailablePlan.loading,
    }),
    ...mapGetters({
      useServiceName: 'companiesCompany/useServiceName',
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    currentPlanId() {
      return this.upgradable_plans_meta.current_plan_id
    },
    selectedPlan() {
      return this.upgradable_plans.find(v => v.id === this.plan_id)
    },
    submitBtnStyle() {
      return {
        'c-button__item p-availablePlan__form__price-board__bottom__submit-button': true,
        'c-button__item--outline-primary': this.validButton(),
        'c-button__item--disabled': !this.validButton(),
      }
    },
    upgradablePlansOptions() {
      const obj = {}
      this.upgradable_plans.map(v => {
        obj[this.formatOption(v)] = v.id
      })
      return obj
    },
    servicePrivacyUrl() {
      return allServiceUrlConst[this.useServiceName].privacy
    },
  },
  async created() {
    await this.readUpgradablePlans(this.currentCompanyUuid)
    this.plan_id = this.currentPlanId
  },
  methods: {
    ...mapActions({
      readUpgradablePlans: 'companiesUpgradablePlans/readUpgradablePlans',
      writeAvailablePlan: 'companiesAvailablePlan/writeAvailablePlan',
    }),
    formatOption(plan) {
      return plan.id != this.currentPlanId
        ? this.$tc('labels.storesCount', plan.attributes.max_store_count)
        : this.$tc('labels.storesCount', plan.attributes.max_store_count) + this.$t('labels.current')
    },
    notCurrentPlanId() {
      return this.plan_id != this.currentPlanId
    },
    validButton() {
      return this.isAgree && this.notCurrentPlanId()
    },
    async onSubmit() {
      const isSuccess = await this.writeAvailablePlan({ company_uuid :this.currentCompanyUuid, plan_id: this.plan_id, update_kind: 'plan_upgrade' })
      if (isSuccess) {
        this.$router.push({ name: 'PaymentSetting', params: { company_uuid: this.currentCompanyUuid }})
      }
    },
  },
}
</script>
